import { FormLibrary } from '@goldcast/api/backend';

import { RegistrationForm, RegistrationForms } from './types';

export function transformRegistrationForm(registrationForms: Array<RegistrationForm | FormLibrary>): RegistrationForms {
  const transformedForms = {};
  registrationForms.forEach(registrationForm => {
    transformedForms[registrationForm.id] = registrationForm;
  });

  return transformedForms;
}
